import actions from "../../actions";

const initialState = {
  fetching: false,
  data: [],
  error: false,
};

const scheduleSession = (data, array) => {
  return array.map((item) => {
    if (item.Session.ID === data.id) {
      return {
        ...item,
        Session: {
          ...item.Session,
          from: data.time.from,
          to: data.time.to,
          Status: 3,
        },
      };
    }

    return item;
  });
};

const suspendSession = (id, array) => {
  return array.map((item) => {
    if (item.Session.ID === id) {
      return {
        ...item,
        Session: {
          ...item.Session,
          Status: 11,
          from: "",
          to: "",
        },
      };
    }

    return item;
  });
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.dashboard.upcommingSessions.FETCH_UPCOMING_SESSIONS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case actions.dashboard.upcommingSessions.FETCH_UPCOMING_SESSIONS_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: [
          ...state.data,
          ...(action.payload === null ? [] : action.payload),
        ],
        error: false,
      };
    case actions.dashboard.upcommingSessions.FETCH_UPCOMING_SESSIONS_ERROR:
      return {
        ...state,
        fetching: false,
        error: true,
      };
    case actions.dashboard.sessions.SCHEDULE_A_SESSION:
      return {
        ...state,
        data: scheduleSession(action.data, state.data),
      };
    case actions.dashboard.sessions.SUSPEND_A_SESSION:
      return {
        ...state,
        data: suspendSession(action.id, state.data),
      };
    default:
      return state;
  }
};
